ko.bindingHandlers.report = {
    init: function (elem: HTMLElement, valueAccessor, allBindings, viewModel, bindingContext) {

        elem.style.display = 'none';

        const result = valueAccessor()


        let from, to;
        if (typeof result === 'string') {
            from = result;
            to = result
        }else if (typeof result === 'function') {
            result;

        } else {
            from = result.from;
            to = result.to;
        }

        const fromObs = bindingContext[from];
        const ToObs = ko.getObservable(viewModel, to)


        if (!fromObs)
            throw new Error(`Could not find '${from}' in bindingContext. Is this property set via the 'let'-binding?`)

        if (!ToObs)
            throw new Error(`Could not find '${to}' in the current viewModel`, viewModel)

        ToObs(fromObs());
        fromObs.subscribe(function (value) {

            ToObs(value);
        });

    }
};

ko.virtualElements.allowedBindings.animate = true;
